import { Link } from 'react-router-dom';
import { ROUTES } from '@/config/routes';

const NotAllowed = () => (
  <div className="flex items-center justify-center py-10 h-screen">
    <div className="w-full max-w-2xl rounded-xl border border-slate-200 bg-white p-8 shadow-sm text-center">
      <h2 className="mt-3 text-2xl font-bold text-gray-900">
        У вас нет прав доступа к этой странице
      </h2>
      <p className="mt-2 text-gray-600">
        Обратитесь к администратору, если считаете, что доступ должен быть предоставлен.
      </p>
      <Link to={ROUTES.HOME} className="block mt-2 text-blue-600 hover:text-blue-800">
        На главную
      </Link>
    </div>
  </div>
);

export default NotAllowed;
